module.exports = __webpack_public_path__ + "static/media/4.1c39a889.png";